import apiService from '../services/apiService';

/**
 * Contexto de navegação entre a fila de Reclamações e a revisão.
 *
 * Ao abrir um item, a fila guarda (sessionStorage) os parâmetros da lista que estava na tela e a
 * ordem dos atendimentos. O "Enviar e abrir a próxima" da revisão usa isso para seguir a MESMA
 * lista: recarrega com os mesmos filtros (o enviado já não está pendente) e pega o primeiro
 * pendente que vinha DEPOIS do atual na ordem vista; se não houver, o primeiro pendente que sobrou.
 */
const NAV_KEY = 'vr-nav:v1';

export function saveNavContext(ctx) {
    try { sessionStorage.setItem(NAV_KEY, JSON.stringify({ ...ctx, savedAt: Date.now() })); } catch (e) { /* ignore */ }
}

export function readNavContext(subdomain) {
    try {
        const c = JSON.parse(sessionStorage.getItem(NAV_KEY) || 'null');
        return c && c.subdomain === subdomain ? c : null;
    } catch (e) { return null; }
}

// -> transcription_id do próximo pendente, ou null
export async function findNextPending({ userId, subdomain, currentTid }) {
    const ctx = readNavContext(subdomain);
    if (!ctx) return null;
    const r = await apiService.pointsDisputesList({ userId, ...ctx.params, subdomain });
    if (!r || !Array.isArray(r.disputes)) return null;
    const pending = new Set(r.disputes.filter((d) => !d.is_reviewed && d.transcription_id !== currentTid)
        .map((d) => d.transcription_id));
    if (!pending.size) return null;
    const seen = ctx.tids || [];
    const idx = seen.indexOf(currentTid);
    const after = seen.slice(idx + 1).find((t) => pending.has(t));
    const next = after || r.disputes.find((d) => pending.has(d.transcription_id)).transcription_id;
    // a lista "vista" passa a ser a recarregada, para o próximo "próxima" seguir dela
    saveNavContext({ ...ctx, tids: r.disputes.map((d) => d.transcription_id) });
    return next;
}
